import React, { useRef, useContext, useState } from "react";
import "./device.css";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import { Formik, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import { DeviceSection } from "../../context/DeviceContext";
import QrReader from "react-qr-reader";
import { deviceWidgetsDisjoined } from "../../api";
import { Alert } from "../";
import { setDeviceWidgetsDisjoined } from "../../redux";
import { withRouter } from "react-router-dom";
import { DeviceMineContext } from "../../context/DeviceMineContext";
import { useTranslation } from "react-i18next";

const ScanDeviceComp = (props) => {
  const { t } = useTranslation();
  const token = Cookies.get("token");
  const dispatch = useDispatch();
  const { deviceMine, setDeviceMine } = useContext(DeviceMineContext);
  const { ShowHideDeviceFunction } = useContext(DeviceSection);
  const [scanResault, setScanResault] = useState(null);
  const form = useRef(null);
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });
  const initialValues = {
    serial: "",
  };

  const submitForm = () => {
    const formData = new FormData(form.current);
    deviceWidgetsDisjoined(formData, token)
      .then((res) => {
        console.log(res.data.data[0]);
        dispatch(setDeviceWidgetsDisjoined(res.data.data));
        ShowHideDeviceFunction("allDevices");
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        } else {
          setShowAlert((prevState) => ({
            ...prevState,
            show: true,
            message: t("این دستگاه موجود نمی باشد."),
            type: "Error",
          }));
          setTimeout(() => {
            setShowAlert((prevState) => ({
              ...prevState,
              show: false,
            }));
          }, 3000);
        }
      });
  };

  const validationSchema = Yup.object({
    serial: Yup.string().required(t("سریال دستگاه را وارد کنید.")),
  });

  const handleScan = (resualt) => {
    if (resualt) {
      setScanResault(resualt);
      initialValues.serial = resualt;
    }
  };

  const handleError = (err) => {
    // alert(err)
  };

  return (
    <div>
      <div className="mb-4">
        <QrReader
          // delay={300}
          onError={handleError}
          onScan={handleScan}
          style={{ width: "100%" }}
          facingMode="environment"
        />
      </div>
      <span className="qrCodeIcon d-block m-auto text-center">
        <i className="icon-video"></i>
      </span>
      <Formik
        initialValues={initialValues}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        {(props) => (
          <Form ref={form}>
            <div className="mt-4 mb-5">
              <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                {props.values.serial && (
                  <p className="fn12 m-0 text-right">{t("سریال دستگاه")}</p>
                )}
                <input
                  type="text"
                  placeholder={t("سریال دستگاه")}
                  name="serial"
                  className="w-100 text-center fn12"
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  defaultValue={scanResault}
                />
              </div>
              <ErrorMessage name="serial">
                {(errMsg) => (
                  <div className="text-danger text-right fn10 mt-1">
                    {errMsg}
                  </div>
                )}
              </ErrorMessage>
            </div>
            <div className="d-flex flex-wrap justify-content-center mt-5">
              <button
                type="submit"
                className="border-0 bg-transparent mx-3 d-flex justify-content-center align-items-center flex-column text-center"
              >
                <span className="profileAddUser bg-white d-block icon-ok cursor"></span>
                <small className="fn12 mt-1">{t("بعدی")}</small>
              </button>
              <div
                className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
                onClick={() => ShowHideDeviceFunction("firstPage")}
              >
                <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
                <small className="fn12 mt-1">{t("بازگشت")}</small>
              </div>
            </div>
          </Form>
        )}
      </Formik>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const ScanDevice = withRouter(ScanDeviceComp);

export { ScanDevice };
